import { TGetOrderResponse, TPageSettingsResponse } from '@p2p/services';
import { MSP_PAGE } from '@p2p/shared/constants';
import { useEffect } from 'react';
import { useLocation, useMatch, useNavigate } from 'react-router-dom';

import { resolveRoute } from './MatchingPayment.utils';

export const useMatchingPaymentNavigation = (
  order?: TGetOrderResponse,
  pageSettings?: TPageSettingsResponse,
  isFetching?: boolean,
) => {
  const navigate = useNavigate();
  const location = useLocation();

  const cancelMatch = useMatch(`${MSP_PAGE}/:id/canceled`);

  useEffect(() => {
    if (!order || !pageSettings || isFetching) return;

    const route = resolveRoute(order, pageSettings);

    if (!route) return;

    const isSameRoute = location.pathname.endsWith(route);

    if (!cancelMatch && !isSameRoute) {
      navigate(route, { replace: true });
    }
  }, [cancelMatch, location.pathname, navigate, order, pageSettings, isFetching]);
};
